
import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);

// var http='http://192.168.1.188:8001';
var http='https://www.wiicent.com:8001';
// var http='http://192.168.10.184:8001';
const state = {

    pageNum:50,//table每页多少条
    thisMOdule:'module',//leftNav切换时显示对应的模块tab
    interface:{
        Code:http+'/gwApply/gwApplyOne',//提交手机号，获取验证码
        login:http+'/gwApply/gwApplyTwo',//提交账户密码

        gwCustomerApplyView:http+'/gwApplyView/gwCustomerApplyView',//获取基本信息
        gwApplyThree:http+'/gwApply/gwApplyThree',//提交基本信息
        // 达人认证
        gwTalentApplyView:http+'/gwApplyView/gwTalentApplyView',//获取达人认证
        gwTalentApply:http+'/gwApply/gwTalentApply',//提交达人认证
        // 供应商
        gwSupplierApplyView:http+'/gwApplyView/gwSupplierApplyView',//获取供应商
        gwSupplierApply:http+'/gwApply/gwSupplierApply',//提交供应商

        // 地区
        areaList:http+'/area/areaList',//地区联动
        // 头像
        customerSetAvater:http+'/customer/customerSetAvater',//头像
        // 图片
        fileUpload:http+'/fileUpload/fileUpload',//图片



        getAgreement: `${http}/wbBkApplyLog/wbBkApplyAgreement`,// 协议
        wbBkApplyLogSubmit: `${http}/wbBkApplyLog/wbBkApplyLogSubmit`,// 申请使用
    }
};





export default new Vuex.Store({
    state,
    modules: {
        // product,

    },
});



// WEBPACK FOOTER //
// ./src/store/index.js